import { render } from "./UserPage.vue?vue&type=template&id=208aa29a"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"
script.render = render

export default script